import feedType from './feedTypes';
import {
  StyledCheckInIcon,
  StyledClientStatusIcon,
  StyledDailySummaryIcon,
  StyledNeedNewWorkoutIcon,
  StyledNeedMealPlanIcon,
  StyledPauseRequestIcon,
  StyledSpecialRemindersIcon,
  StyledArchivedIcon,
  StyledVideoFeedbackIcon,
  StyledDisengagedClientIcon,
  StyledCoachTaskIcon,
  StyledUserPreferenceChangeIcon,
  StyledWorkoutConflictReviewIcon,
  StyledToDoIcon,
} from './styles';
import texts from './texts';

const feedTypeConfig = {
  [feedType.NEED_NEW_WORKOUTS]: {
    title: texts[feedType.NEED_NEW_WORKOUTS],
    icon: StyledNeedNewWorkoutIcon,
  },
  [feedType.NEED_NEW_MEAL_PLAN]: {
    title: texts[feedType.NEED_NEW_MEAL_PLAN],
    icon: StyledNeedMealPlanIcon,
  },
  [feedType.DAILY_SUMMARY]: {
    title: texts[feedType.DAILY_SUMMARY],
    icon: StyledDailySummaryIcon,
  },
  [feedType.ARCHIVED]: {
    title: texts[feedType.ARCHIVED],
    icon: StyledArchivedIcon,
  },
  [feedType.CHECK_IN]: {
    title: texts[feedType.CHECK_IN],
    icon: StyledCheckInIcon,
  },
  [feedType.CLIENT_STATUS]: {
    title: texts[feedType.CLIENT_STATUS],
    icon: StyledClientStatusIcon,
  },
  [feedType.SPECIAL]: {
    title: texts[feedType.SPECIAL],
    icon: StyledSpecialRemindersIcon,
  },
  [feedType.PAUSE_REQUEST]: {
    title: texts[feedType.PAUSE_REQUEST],
    icon: StyledPauseRequestIcon,
  },
  [feedType.WORKOUT_FEEDBACK_REQUEST]: {
    title: texts.WORKOUT_FEEDBACK_REQUEST,
    icon: StyledVideoFeedbackIcon,
  },
  [feedType.DISENGAGED_CLIENT]: {
    title: texts[feedType.DISENGAGED_CLIENT],
    icon: StyledDisengagedClientIcon,
  },
  [feedType.COACH_TASK]: {
    title: texts[feedType.COACH_TASK],
    icon: StyledCoachTaskIcon,
  },
  [feedType.TODO]: {
    title: texts[feedType.TODO],
    icon: StyledToDoIcon,
  },
  [feedType.USER_PREFERENCE_CHANGE]: {
    title: texts[feedType.USER_PREFERENCE_CHANGE],
    icon: StyledUserPreferenceChangeIcon,
  },
  [feedType.WORKOUT_CONFLICT_REVIEW]: {
    title: texts[feedType.WORKOUT_CONFLICT_REVIEW],
    icon: StyledWorkoutConflictReviewIcon,
  },
};

export default feedTypeConfig;
